var exports = {
  "O": "NotificationDot.module__dot___dzNQZV",
  "s": "NotificationDot.module__srOnly___dzNQZV",
};

module.exports = exports;
